import { ToastDesignTokens } from '@primeuix/themes/types/toast';

import { getRem } from '@customer-portal/shared/helpers/theme-utils';

export const toastOverride: ToastDesignTokens = {
  root: {
    borderRadius: getRem(10),
  },

  text: {
    gap: getRem(9),
  },

  closeButton: {
    width: getRem(24),
    height: getRem(24),
  },
};
